
import CutString from '@/filters/cut-string'
export default {
    filters: {
        'cutString': CutString,
    },
    methods: {
        getShopNameByData(shopData) {
            const defaultName = '门店名称未设置';
            let viewName = null;
            try {
                const { osname, name } = shopData;
                const osName = osname || '';
                const sName = name || '';
                viewName = (osName.trim()) || (sName.trim()) || defaultName;
            } catch (error) {
                return defaultName;
            }
            return viewName || defaultName;
		},
    },
}